<template>
  <div id="tabelaAvaliacoes" class="tabela-avaliacoes-wrapper w-100 m-0 d-flex flex-column align-items-center border rounded">
    <b-table class="serigy-avaliacoes-detalhe-table" :fields="fieldsItens" :items="listaAvaliacoes"
      :busy="tableBusyItens" :tbody-tr-class="rowClass" hover no-border-collapse striped small sort-by="" stacked="lg" responsive show-empty>
      <template #empty>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #emptyfiltered>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #table-busy>
        <div class="text-center text-dark">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="loading-text">Carregando...</strong>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <b-link class="text-dark serigy-action-link" @click="alertaReavaliarAvaliacao(row.item)">
          <font-awesome-icon icon="redo" />
          <div class="serigy-action-label">Reavaliar</div>
        </b-link>
      </template>
      <template v-slot:cell(respostas)="row">
        <b-link class="text-dark" @click="row.toggleDetails">
          <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
        </b-link>
      </template>
      <template #cell(ug)="row">
        <span class="ug-label-serigy">
          {{ formatUgSigla(row.item.ug) }}
        </span>
      </template>
      <template #row-details="row">
        <TabelaRespostas :avaliacao="row.item" :isAvaliacaoGeral="true" />
      </template>
      <template v-slot:cell(dsSituacao)="row">
        <span class="badge sitBadge" :class="row.item.classSituacao">
          {{ row.item.dsSituacao }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import serigyService from "@/services/administracao/serigyService";
import { TableField } from "@/types/table-field";
import { fieldsAvaliacoesComUg, actions } from "@/types/administracao/serigy/invoker/fields-invoker-avaliacoes";
import TabelaRespostas from "@/components/serigy/TabelaRespostas.vue";
import { PropType } from "vue";
import { Avaliacao } from "@/types/administracao/serigy/invoker/avaliacao";
import { AvaliacaoGeral } from "@/types/administracao/serigy/avaliacao-geral/avaliacao-geral";

const CompProps = Vue.extend({
  name: "TabelaAvaliacoes",
  props: {
    avaliacaoGeral: {
      type: Object as PropType<AvaliacaoGeral>,
      required: true,
    },
  },
  components: {
    TabelaRespostas,
  }
});

@Component
export default class TabelaAvaliacoes extends mixins(UtilsTS, CompProps) {
  fieldsItens: TableField[] = [...fieldsAvaliacoesComUg, actions];
  listaAvaliacoes: Avaliacao[] = [];
  tableBusyItens = false;
  private readonly nonBreakingHyphen = "\u2011";

  formatUgSigla(
    ugValue:
      | string
      | { codUgSagres?: string; nmSigla?: string }
      | null
      | undefined
  ): string {
    const sigla =
      typeof ugValue === "string"
        ? ugValue
        : ugValue?.nmSigla ?? "";
    return sigla.replace(/-/g, this.nonBreakingHyphen);
  }

  rowClass(item: any): string {
    if (!item) return "";
    return item._classeLinhaSerigy || "";
  }

  async mounted(): Promise<void> {
    this.loadData();
  }

  async loadData(): Promise<void> {
    try {
      this.tableBusyItens = true;
      const retorno = await serigyService.listarAvaliacoesPorAvaliacaoGeral(
        this.avaliacaoGeral.id,
      );
      this.listaAvaliacoes = retorno.map((item: Avaliacao, index: number) => {
        return Object.assign(item, {
          _classeLinhaSerigy: index % 2 === 0 ? "linha-branca-serigy" : "linha-cinza-serigy",
        });
      });
    } catch (e) {
      this.listaAvaliacoes = [];
      this.tratarError(e);
    } finally {
      this.tableBusyItens = false;
    }
  }

  async reavaliarAvaliacao(avaliacao: Avaliacao): Promise<void> {
    try {
      await serigyService.reavaliarAvaliacao(avaliacao.id);
      await this.loadData();
    } catch (error) {
      this.tratarError(error);
    }
  }

  alertaReavaliarAvaliacao(avaliacao: Avaliacao): any {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja reavaliar a avaliação?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          okVariant: "secondary",
          title: "Reavaliar Avaliação",
        }
      )
      .then((value) => {
        if (value) {
          if (avaliacao.id) {
            this.reavaliarAvaliacao(avaliacao);
          }
        }
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de reavaliação de avaliação`,
          err
        );
      });
  }
}
</script>
<style scoped>
span.sitBadge.success {
  color: #fff;
  background-color: #28a745;
}

span.sitBadge.warning {
  background-color: #ffc107;
}

span.sitBadge.danger {
  color: #fff;
  background-color: #dc3545;
}
</style>
